export function arrayExists(value) {
  return value !== null && value !== undefined && value.length !== 0;
}

export function MatchOne(target, filter) {
  return filter === null || filter === undefined || filter === target;
}

export function MatchMulti(target, filters) {
  return !arrayExists(filters) || filters.some((v) => v === target);
}

export function FilterStudent(student, filter_params) {
  if (!arrayExists(filter_params.courses) && filter_params.gender === null && filter_params.grade === null) {
    return {
      ...student,
      filter_result: true,
    };
  }
  return {
    ...student,
    filter_result: MatchOne(student.gender, filter_params.gender)
                   && MatchOne(student.grade, filter_params.grade)
                   && MatchMulti(student.courseName, filter_params.courses),
  };
}

export const MatchDates = (attends, filters) => {
  return !arrayExists(filters) || filters.every((v) => {
    const target = attends.find((attend) => attend.date === v);
    return target !== undefined && target.isActive;
  });
};

export const MatchCourseLevel = (coursesPoints, filterCourses, filterLevels) => {
  if (!arrayExists(filterLevels) && !arrayExists(filterCourses)) {
    return true;
  }
  let result = true;
  if (arrayExists(filterCourses)) {
    result = filterCourses.every((v) => coursesPoints.some((course_point) => v === course_point.name));
  }
  if (result && arrayExists(filterLevels)) {
    result = result && filterLevels.every((v) => coursesPoints.some((course_point) => v === course_point.point));
  }
  return result;
};

export function FilterTeam(team, filter_params) {
  if ((!arrayExists(filter_params.courses) && !arrayExists(filter_params.staffTypes))) {
    return {
      ...team,
      filter_result: true,
    };
  }

  const MatchMultiByMulti = (targets, filters) => {
    return arrayExists(filters) && arrayExists(targets) && filters.some((v) => targets.includes(v));
  };

  return {
    ...team,
    filter_result: MatchMultiByMulti(team.courses.map((v) => v.name), filter_params.courses)
                   || MatchMultiByMulti(team.staffTypes.map((staff_type) => staff_type.name), filter_params.staffTypes),
  };
}
